(function () {
  class FeaturedReviewsSection extends HTMLElement {
    constructor() {
      super();
      this._swiper = null;
      this._nextButtons = [];
      this._onShopifyEvent = this._onShopifyEvent.bind(this);
      this._onNextClick = this._onNextClick.bind(this);
    }

    connectedCallback() {
      if (!window.Swiper) {
        return;
      }
      this._initSwiper();
      document.addEventListener('shopify:section:load', this._onShopifyEvent);
      document.addEventListener('shopify:block:select', this._onShopifyEvent);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this._onShopifyEvent);
      document.removeEventListener('shopify:block:select', this._onShopifyEvent);
      this._destroySwiper();
    }

    _onShopifyEvent(event) {
      var target = event.target;
      if (target && typeof target.contains === 'function' && target.contains(this)) {
        this._destroySwiper();
        var self = this;
        setTimeout(function () {
          self._initSwiper();
        }, 500);
      }
    }

    _onNextClick() {
      if (this._swiper && typeof this._swiper.slideNext === 'function') {
        this._swiper.slideNext();
      }
    }

    _unbindNext() {
      var self = this;
      this._nextButtons.forEach(function (btn) {
        btn.removeEventListener('click', self._onNextClick);
      });
      this._nextButtons = [];
    }

    _destroySwiper() {
      this._unbindNext();
      if (this._swiper && typeof this._swiper.destroy === 'function') {
        this._swiper.destroy(true, true);
        this._swiper = null;
      }
    }

    _initSwiper() {
      if (!window.Swiper) {
        return;
      }

      this._destroySwiper();

      var elCarousel = this.querySelector('.swiper-container');
      if (!elCarousel) {
        return;
      }

      var elReviews = elCarousel.querySelectorAll('.featured-reviews__review');
      if (!elReviews.length) {
        return;
      }

      var layout = this.getAttribute('data-layout') || 'cards';

      var elPaginationBullets = this.querySelector('.featured-reviews__pagination .bullets');
      var elPaginationParent = elPaginationBullets ? elPaginationBullets.parentElement : null;

      if (layout === 'cards' && elReviews.length <= 3 && elPaginationParent) {
        elPaginationParent.classList.add('hide-tablet');
      } else if (elPaginationParent) {
        elPaginationParent.classList.remove('hide-tablet');
      }

      var paginationConfig = {
        el: elPaginationBullets,
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        },
      };

      var baseOptions = {
        slidesPerView: layout === 'cards' ? elReviews.length : 1,
        spaceBetween: layout === 'cards' ? 0 : 20,
        loop: layout === 'cards' ? false : true,
        allowTouchMove: layout === 'cards' ? false : true,
        pagination: paginationConfig,
      };

      var breakpoints = {
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 20,
          loop: elReviews.length > 3,
          allowTouchMove: elReviews.length > 3,
        },
        1024: {
          slidesPerGroup: 3,
          slidesPerView: 3,
          spaceBetween: 20,
          loop: elReviews.length > 3,
          allowTouchMove: elReviews.length > 3,
        },
        1440: {
          slidesPerGroup: 3,
          slidesPerView: 3,
          spaceBetween: 40,
          loop: elReviews.length > 3,
          allowTouchMove: elReviews.length > 3,
        },
      };

      var options =
        layout === 'image'
          ? baseOptions
          : Object.assign({}, baseOptions, { breakpoints: breakpoints });

      this._swiper = new window.Swiper(elCarousel, options);

      var self = this;
      this.querySelectorAll('.featured-reviews__next, .featured-reviews__pagination .next').forEach(
        function (btn) {
          btn.addEventListener('click', self._onNextClick);
          self._nextButtons.push(btn);
        }
      );
    }
  }

  if (!customElements.get('featured-reviews-section')) {
    customElements.define('featured-reviews-section', FeaturedReviewsSection);
  }
})();
